module.exports = __webpack_public_path__ + "favicon-stg-d7a093cd6e0955550d11865601fa83c6.ico";